module.exports = "<div id=\"button\">\n    <button type=\"button\" class=\"btn btn-primary btn-lg\" (click)=\"onClickButton($event)\">\n    </button>\n</div>"